/**
 * Assessment type ids and helpers.
 *
 * Type 3 ("360 Feedback") and type 4 ("270 Feedback") share the same self/manager/reportee
 * feedback plumbing. 270 additionally supports subjective (free-text) questions. Code that gates
 * "feedback behaviour" should use isFeedbackType() rather than a hardcoded `=== 3`.
 *
 * If the DB migration seeded "270 Feedback" with an id other than 4, update FEEDBACK_270_TYPE_ID
 * here and in the backend / carve-assessment config files to match.
 */
export const FEEDBACK_360_TYPE_ID = 3;
export const FEEDBACK_270_TYPE_ID = 4;

export const FEEDBACK_TYPE_IDS: number[] = [FEEDBACK_360_TYPE_ID, FEEDBACK_270_TYPE_ID];

export const isFeedbackType = (typeId: number | string | null | undefined): boolean =>
  typeId != null && FEEDBACK_TYPE_IDS.includes(Number(typeId));

/** 270-only: assessments that also collect subjective (free-text) answers. */
export const isSubjectiveFeedbackType = (typeId: number | string | null | undefined): boolean =>
  Number(typeId) === FEEDBACK_270_TYPE_ID;
